const normalizeToken = value => String(value || '').trim().toLowerCase();

export const ACCOUNTING_MAPPING_PRESETS = [
  {
    key: 'sale:sales',
    label: 'Sales revenue',
    description: 'Akun pendapatan utama untuk transaksi penjualan POS.',
    transactionType: 'sale',
    purpose: 'sales',
    category: 'Revenue',
    importance: 'core',
  },
  {
    key: 'sale:cash',
    label: 'Cash settlement',
    description: 'Akun kas utama untuk transaksi tunai dari cashier.',
    transactionType: 'sale',
    purpose: 'cash',
    category: 'Asset',
    importance: 'core',
  },
  {
    key: 'purchase:inventory',
    label: 'Inventory asset',
    description: 'Akun persediaan yang dipakai saat pembelian barang dan reversal COGS.',
    transactionType: 'purchase',
    purpose: 'inventory',
    category: 'Asset',
    importance: 'core',
  },
  {
    key: 'purchase:cash',
    label: 'Purchase cash',
    description: 'Akun pembayaran pembelian tunai.',
    transactionType: 'purchase',
    purpose: 'cash',
    category: 'Asset',
    importance: 'core',
  },
  {
    key: 'sale:qris',
    label: 'QRIS settlement',
    description: 'Siapkan jika outlet menerima pembayaran QRIS di kasir.',
    transactionType: 'sale',
    purpose: 'qris',
    category: 'Asset',
    importance: 'extended',
  },
  {
    key: 'sale:transfer',
    label: 'Transfer settlement',
    description: 'Siapkan jika outlet menerima transfer bank langsung dari POS.',
    transactionType: 'sale',
    purpose: 'transfer',
    category: 'Asset',
    importance: 'extended',
  },
  {
    key: 'sale:receivable',
    label: 'Customer receivable',
    description: 'Siapkan jika outlet mencatat penjualan hutang customer atau termin proyek dari POS.',
    transactionType: 'sale',
    purpose: 'receivable',
    category: 'Asset',
    importance: 'extended',
  },
  {
    key: 'sale:return_credit',
    label: 'Return credit liability',
    description: 'Siapkan jika outlet ingin menyelesaikan retur sebagai voucher, saldo retur, atau belanja kembali.',
    transactionType: 'sale',
    purpose: 'return_credit',
    category: 'Liability',
    importance: 'extended',
  },
  {
    key: 'sale:tax',
    label: 'Sales tax',
    description: 'Dipakai saat transaksi mengandung pajak penjualan.',
    transactionType: 'sale',
    purpose: 'tax',
    category: 'Liability',
    importance: 'extended',
  },
  {
    key: 'sale:service',
    label: 'Service charge',
    description: 'Dipakai untuk menampung pungutan service charge restoran (sebagai Kewajiban titipan staf atau Pendapatan).',
    transactionType: 'sale',
    purpose: 'service',
    category: 'Liability',
    importance: 'extended',
  },
  {
    key: 'sale:discount',
    label: 'Sales discount',
    description: 'Dipakai saat cashier memberi potongan penjualan.',
    transactionType: 'sale',
    purpose: 'discount',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'sale:cogs',
    label: 'Cost of goods sold',
    description: 'Direkomendasikan agar laba rugi POS dan inventory berjalan akrual.',
    transactionType: 'sale',
    purpose: 'cogs',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'purchase:credit',
    label: 'Purchase payable',
    description: 'Siapkan jika outlet mencatat pembelian kredit / hutang dagang.',
    transactionType: 'purchase',
    purpose: 'credit',
    category: 'Liability',
    importance: 'extended',
  },
];

export const ACCOUNTING_FORM_TEMPLATES = [
  ...ACCOUNTING_MAPPING_PRESETS,
  {
    key: 'inventory:adjustment_loss',
    label: 'Stock adjustment loss',
    description: 'Canonical mapping untuk selisih stok minus dari stock adjustment atau stock opname.',
    transactionType: 'inventory',
    purpose: 'adjustment_loss',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'inventory:adjustment_gain',
    label: 'Stock adjustment gain',
    description: 'Canonical mapping untuk selisih stok plus dari stock adjustment atau stock opname.',
    transactionType: 'inventory',
    purpose: 'adjustment_gain',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'expense:inventory_adjustment',
    label: 'Inventory adjustment expense',
    description: 'Fallback mapping jika outlet memakai akun beban adjustment inventory.',
    transactionType: 'expense',
    purpose: 'inventory_adjustment',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'expense:stock_loss',
    label: 'Stock loss expense',
    description: 'Fallback mapping untuk kerugian stok / shrinkage.',
    transactionType: 'expense',
    purpose: 'stock_loss',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'income:inventory_adjustment',
    label: 'Inventory adjustment income',
    description: 'Fallback mapping jika outlet memakai akun pendapatan adjustment inventory.',
    transactionType: 'income',
    purpose: 'inventory_adjustment',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'income:stock_gain',
    label: 'Stock gain income',
    description: 'Fallback mapping untuk temuan stok atau penyesuaian stok plus.',
    transactionType: 'income',
    purpose: 'stock_gain',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'expense:cash_shortage',
    label: 'Cash shortage expense',
    description: 'Dipakai saat closing shift menemukan kas aktual lebih kecil dari kas sistem.',
    transactionType: 'expense',
    purpose: 'cash_shortage',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'income:cash_overage',
    label: 'Cash overage income',
    description: 'Dipakai saat closing shift menemukan kas aktual lebih besar dari kas sistem.',
    transactionType: 'income',
    purpose: 'cash_overage',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'other_income:cash_overage',
    label: 'Cash overage other income',
    description: 'Fallback jika surplus kas closing shift dikelompokkan ke other income.',
    transactionType: 'other_income',
    purpose: 'cash_overage',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'other_income:inventory_adjustment',
    label: 'Inventory adjustment other income',
    description: 'Fallback mapping jika akun lawan gain adjustment dikelompokkan ke other income.',
    transactionType: 'other_income',
    purpose: 'inventory_adjustment',
    category: 'Revenue',
    importance: 'extended',
  },
  {
    key: 'fee:expense',
    label: 'Outlet fee expense',
    description: 'Mapping opsional jika billing outlet bulanan ingin dipost terpisah dari sale POS.',
    transactionType: 'fee',
    purpose: 'expense',
    category: 'Expense',
    importance: 'extended',
  },
  {
    key: 'fee:balance',
    label: 'Outlet fee balance',
    description: 'Mapping opsional untuk akun lawan billing outlet bulanan.',
    transactionType: 'fee',
    purpose: 'balance',
    category: 'Liability',
    importance: 'extended',
  },
];

export const OUTLET_FEE_EXPENSE_CANDIDATES = [
  { transactionType: 'fee', purpose: 'expense' },
  { transactionType: 'fee', purpose: 'outlet_fee' },
  { transactionType: 'sale', purpose: 'outlet_fee' },
  { transactionType: 'sale', purpose: 'fee_expense' },
];

export const OUTLET_FEE_BALANCE_CANDIDATES = [
  { transactionType: 'fee', purpose: 'balance' },
  { transactionType: 'fee', purpose: 'outlet_balance' },
  { transactionType: 'balance', purpose: 'outlet' },
  { transactionType: 'balance', purpose: 'liability' },
  { transactionType: 'deposit', purpose: 'balance' },
];

export const accountMatches = (account, transactionType, purpose) =>
  normalizeToken(account?.transaction_type) === normalizeToken(transactionType) &&
  normalizeToken(account?.purpose) === normalizeToken(purpose);

export const findMappedAccount = (accounts, transactionType, purpose) =>
  (accounts || []).find(account => accountMatches(account, transactionType, purpose)) || null;

export const findMappedAccountByCandidates = (accounts, candidates) =>
  (candidates || [])
    .map(candidate => findMappedAccount(accounts, candidate.transactionType, candidate.purpose))
    .find(Boolean) || null;

export const buildAccountingChecklist = accounts => {
  const baseItems = ACCOUNTING_MAPPING_PRESETS
    .filter(preset => normalizeToken(preset.transactionType) !== 'fee')
    .map(preset => {
      const account = findMappedAccount(accounts, preset.transactionType, preset.purpose);
      return {
        ...preset,
        account,
        configured: Boolean(account),
        centralMatched: false,
      };
    });

  return baseItems;
};

export const summarizeAccountingChecklist = checklist => {
  const items = Array.isArray(checklist) ? checklist : [];
  const coreItems = items.filter(item => item.importance === 'core');
  const extendedItems = items.filter(item => item.importance !== 'core');

  return {
    coreTotal: coreItems.length,
    coreReady: coreItems.filter(item => item.configured).length,
    extendedTotal: extendedItems.length,
    extendedReady: extendedItems.filter(item => item.configured).length,
    centralMatched: items.filter(item => !item.account || item.centralMatched).length,
    total: items.length,
  };
};

export const getCentralAccountMap = accounts =>
  new Map((accounts || []).map(account => [String(account.AccountID || account.account_id || '').trim(), account]));

export const withCentralAccountStatus = (checklist, centralAccounts) => {
  const centralMap = getCentralAccountMap(centralAccounts);

  return (checklist || []).map(item => {
    if (!item.account?.id) {
      return { ...item, centralMatched: !item.account };
    }

    return {
      ...item,
      centralMatched: centralMap.has(String(item.account.id).trim()),
    };
  });
};

export const formatMappingKey = (transactionType, purpose) =>
  `${normalizeToken(transactionType)}:${normalizeToken(purpose)}`;

export const findAccountingTemplateByKey = key =>
  ACCOUNTING_FORM_TEMPLATES.find(template => template.key === String(key || '').trim()) || null;
